/* eslint-disable @typescript-eslint/no-explicit-any */
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import {defaultErrorValues} from '../../data/constants/Assurance/AssuranceVoyage/devis';
import {
  defaultErrorAssured,
  defaultErrorValues as defaultSouscriptionErrorValues,
} from '../../data/constants/Assurance/AssuranceVoyage/souscription';
import {IError} from '../../data/types/interface/Assurance/AssuranceVoyage/devis';
import {IError as ISouscriptionError} from '../../data/types/interface/Assurance/AssuranceVoyage/souscription';
import {
  MAIL_VALIDATION,
  MESSAGE_VALIDATION,
  PHONE_NUMBER_VALIDATION,
} from './validation';

import {
  defaultErrorAssured as defaultModificationErrorAssured,
  defaultErrorValues as defaultModificationErrorValues,
} from '../../data/constants/Assurance/AssuranceVoyage/modification';
import {defaultErrorValues as defaultResiliationErrorValues} from '../../data/constants/Assurance/AssuranceVoyage/resiliation';
import {IError as IModificationError} from '../../data/types/interface/Assurance/AssuranceVoyage/modification';
import {IError as IResiliationError} from '../../data/types/interface/Assurance/AssuranceVoyage/resiliation';

export const ValidationDevis = (values: IError) => {
  let errors: IError = {...defaultErrorValues};

  const dateDebut = dayjs(values.dateDebut);
  const dateFin = dayjs(values.dateFin);
  if (dateDebut.isBefore(dayjs())) {
    errors.dateFin = "La date de début doit être antérieure à aujourd'hui";
  }

  if (dateDebut.isAfter(dateFin)) {
    errors.dateFin =
      'la date de fin doit être supérieure ou égal à la date de début!';
  }

  if (!values.listNaissance.length) {
    errors.listNaissance =
      'Veuillez inserer les dates de naissances des personnes qui partiront en voyage.';
  }

  const propertyException: Array<string> = [
    'dateNaissance',
    'destinationLabel',
    'categoryLabel',
  ];

  /** checking all required values */
  Object.entries(values).forEach(element => {
    if (
      (Boolean(element[1]) == false ||
        element[1] === 'INVALID INPUT' ||
        (Array.isArray(element[1]) && element[1].length === 0)) &&
      !propertyException.includes(element[0])
    ) {
      if (element[0] !== 'motif' && element[0] !== 'type') {
        errors = {...errors, [element[0]]: MESSAGE_VALIDATION.requiredField};
      }
    }
  });

  return errors;
};

export const ValidationSouscription = (
  values: ISouscriptionError,
  listAgence?: [],
) => {
  let errors: ISouscriptionError = {...defaultSouscriptionErrorValues};

  if (values.assure.length) {
    errors.assure = [
      ...values.assure.map((element: any) => ({
        ...defaultErrorAssured,
        id: element.id,
      })),
    ];
  }

  /** agence cheking */

  if (values.agence !== '') {
    const _list = listAgence && [...listAgence];
    const _data =
      _list &&
      _list.filter(
        (item: any) =>
          item.label.toLowerCase().indexOf(values?.agence?.toLowerCase()) > -1,
      );
    const _agence =
      _list && _list.filter((item: any) => item.label === values.agence);

    if ((_data && _data.length === 0) || _agence?.length === 0) {
      errors.agence = MESSAGE_VALIDATION.invalidAgence;
    }
  }

  /** checking all values */

  Object.entries(values).forEach(element => {
    if (element[0] !== 'assure' && (element[1] === '' || element[1] === null)) {
      errors = {...errors, [element[0]]: MESSAGE_VALIDATION.requiredField};
    } else if (element[0] === 'assure') {
      element[1].map((assureElt: any, index: number) => {
        /** check numero de passeport */
        if (!/^[A-Za-z0-9]{6,15}$/.test(assureElt.numPasseport)) {
          errors.assure[index].numPasseport =
            MESSAGE_VALIDATION.invalidPasseport;
        }
        /** check nom */
        if (!/^[A-Za-z0-9 ]*$/.test(assureElt.nom)) {
          errors.assure[index].nom = MESSAGE_VALIDATION.noAccentNorSpecialChar;
        }
        /** check prenom */
        if (!/^[A-Za-z0-9 ]*$/.test(assureElt.prenom)) {
          errors.assure[index].prenom =
            MESSAGE_VALIDATION.noAccentNorSpecialChar;
        }
        /** check email */
        if (!MAIL_VALIDATION.test(assureElt.email)) {
          errors.assure[index].email = MESSAGE_VALIDATION.requiredEmail;
        }

        /** check phone number */
        if (!PHONE_NUMBER_VALIDATION.test(assureElt.telephone)) {
          errors.assure[index].telephone = MESSAGE_VALIDATION.requiredTelephone;
        }

        const elementPropertyException = ['menu'];
        Object.entries(assureElt).forEach(elementProperty => {
          if (
            (elementProperty[1] === '' ||
              elementProperty[1] === null ||
              elementProperty[1] === undefined ||
              (elementProperty[0] === 'passport_file' &&
                Array.isArray(elementProperty[1]) &&
                !elementProperty[1].length)) &&
            !elementPropertyException.includes(elementProperty[0])
          ) {
            errors.assure[index] = {
              ...errors.assure[index],
              [elementProperty[0]]: MESSAGE_VALIDATION.requiredField,
            };
          }
        });
      });
    }
  });

  return errors;
};

export const ValidationResiliation = (values: IError) => {
  let errors: IResiliationError = {...defaultResiliationErrorValues};

  /** checking all values */

  Object.entries(values).forEach(element => {
    if (element[1] === '' || element[1] === null) {
      errors = {...errors, [element[0]]: 'Ce champ est obligatoire'};
    }
  });

  return errors;
};

export const ValidationModification = (values: IModificationError) => {
  let errors: IModificationError = {...defaultModificationErrorValues};

  if (values.assure.length) {
    errors.assure = [
      ...values.assure.map(element => ({
        ...defaultModificationErrorAssured,
        id: element.id,
      })),
    ];
  }

  const dateDebut =
    typeof values.dateDebut == 'object'
      ? dayjs(values.dateDebut)
      : dayjs(values.dateDebut, 'DD/MM/YYYY');
  const dateFin =
    typeof values.dateFin == 'object'
      ? dayjs(values.dateFin)
      : dayjs(values.dateFin, 'DD/MM/YYYY');
  if (dateDebut.isBefore(dayjs())) {
    errors.dateFin = "La date de début doit être antérieure à aujourd'hui";
  }

  if (dateDebut.isAfter(dateFin)) {
    errors.dateFin =
      'La date de fin doit être supérieure ou égal à la date de début!';
  }

  /** checking all values */

  Object.entries(values).forEach(element => {
    if (element[0] !== 'assure' && (element[1] === '' || element[1] === null)) {
      errors = {...errors, [element[0]]: 'Ce champ est obligatoire'};
    } else if (element[0] === 'assure') {
      element[1].map((assureElt: any, index: number) => {
        /** check nom */
        if (!/^[A-Za-z0-9 ]*$/.test(assureElt.nom)) {
          errors.assure[index].nom =
            "Le nom ne doit pas avoir d'accent ou de caractère spéciaux";
        }
        /** check prenom */
        if (!/^[A-Za-z0-9 ]*$/.test(assureElt.prenom)) {
          errors.assure[index].prenom =
            "Le nom ne doit pas avoir d'accent ou de caractère spéciaux";
        }
        /** check email */
        if (!MAIL_VALIDATION.test(assureElt.email)) {
          errors.assure[index].email = "Le format de l'email est incorrect";
        }

        const elementPropertyException = ['menu', 'newImage'];
        Object.entries(assureElt).forEach(elementProperty => {
          if (
            (elementProperty[1] === '' ||
              elementProperty[1] === null ||
              elementProperty[1] === undefined ||
              (elementProperty[0] === 'passeportFile' &&
                Array.isArray(elementProperty[1]) &&
                !elementProperty[1].length)) &&
            !elementPropertyException.includes(elementProperty[0])
          ) {
            errors.assure[index] = {
              ...errors.assure[index],
              [elementProperty[0]]: 'Ce champ est obligatoire',
            };
          }
        });
      });
    }
  });

  return errors;
};
